/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import LoadingContent from '../../components/LoadingContent';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { Container } from 'react-bootstrap';
import wpGeodirServices from "../../services/wpGeodirServices";
import userProgramsService, { SavedResourceLink } from "../../services/userProgramsService";
import toast from 'react-hot-toast';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { logout } from '../../app/basicInformationSlice/basicInformationSlice';
import { routers, appRoutes } from '../../router/router';
import { STRIPE_PRICE_NAME } from '../../constants/common';
import LockIcon from '@mui/icons-material/Lock';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LinkIcon from '@mui/icons-material/Link';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import LanguageIcon from '@mui/icons-material/Language';
import DescriptionIcon from '@mui/icons-material/Description';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from '../../utils/sessionStorage';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import ScienceIcon from '@mui/icons-material/Science';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Checkbox, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { formatDurationWeeks } from './ProgramCard';
import ApplicationFormDropdown from './components/ApplicationFormDropdown';
import RecommendationLettersDropdown, { RecommendationLetterItem } from './components/RecommendationLettersDropdown';
import TranscriptsDropdown, { TranscriptItem } from './components/TranscriptsDropdown';
import ResumeDropdown, { ResumeItem } from './components/ResumeDropdown';
import EssaysDropdown, { EssayItem } from './components/EssaysDropdown';
import ReminderFormDropdown from './components/ReminderFormDropdown';
import ResourceLinkFormDropdown from './components/ResourceLinkFormDropdown';
import { isValidHttpOrHttpsUrl, normalizeResourceUrl } from './utils/resourceLinkValidation';
import { ModalConfirm } from '../common/ModalConfirm';

interface Props {}

/// Show Detail of Program
const ProgramsPage = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const location = useLocation();
  const [count, setCount] = useState<any>(0);
  const [detail, setDetail] = React.useState<any>({});
  const detailRef = useRef(detail);
  detailRef.current = detail;
  const [categories, setCategories] = React.useState<string[]>([]);
  const [applicationFormExpanded, setApplicationFormExpanded] = React.useState(false);
  const [recommendationLettersExpanded, setRecommendationLettersExpanded] = React.useState(false);
  const [addLetterTrigger, setAddLetterTrigger] = React.useState(0);
  const [transcriptsExpanded, setTranscriptsExpanded] = React.useState(false);
  const [addTranscriptTrigger, setAddTranscriptTrigger] = React.useState(0);
  const [resumeExpanded, setResumeExpanded] = React.useState(false);
  const [addResumeTrigger, setAddResumeTrigger] = React.useState(0);
  const [essaysExpanded, setEssaysExpanded] = React.useState(false);
  const [addEssayTrigger, setAddEssayTrigger] = React.useState(0);
  const [programNotes, setProgramNotes] = React.useState('');
  const [applicationDeadline, setApplicationDeadline] = React.useState('');
  /** Application Status (card trên): độc lập với application_form — lưu ở programManager.status */
  const [managerApplicationStatusUi, setManagerApplicationStatusUi] = React.useState<'in_progress' | 'submitted' | null>(null);
  const [isAddingToManager, setIsAddingToManager] = React.useState(false);
  const [reminderFormOpen, setReminderFormOpen] = React.useState(false);
  const [reminders, setReminders] = React.useState<Array<{ title: string; dueDate: string; notes: string; complete?: boolean }>>([]);
  const [deleteReminderIdx, setDeleteReminderIdx] = React.useState<number | null>(null);
  const [resourceLinkFormOpen, setResourceLinkFormOpen] = React.useState(false);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const stripeSubscriptionInfo = useAppSelector((store) => store.basicInformation.stripeSubscriptionInfo);
  const stripeSubscriptionInfoLoaded = useAppSelector((store) => store.basicInformation.stripeSubscriptionInfoLoaded);
  const isTrial = stripeSubscriptionInfoLoaded && (stripeSubscriptionInfo == null || stripeSubscriptionInfo?.subcription_plan === STRIPE_PRICE_NAME.GradMapStarter);
  let studentId = getUserId();
  let token = getAccessToken();
  let query = new URLSearchParams(useLocation().search);  
  let program_id = query.get('id') || '';
    
  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const loadProgram = async () => {
    try {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        setLoading(true);
        let item:any =  await wpGeodirServices.getProgram(program_id);
        if (item) {
              setDetail(item);

              // Build category badges from new fields
              const badges: string[] = [];
              if (item.primary_category) {
                badges.push(item.primary_category);
              }
              if (item.tags) {
                const tagList = String(item.tags)
                  .split(',')
                  .map((t: string) => t.trim())
                  .filter((t: string) => t.length > 0);
                badges.push(...tagList);
              }
              setCategories(badges);
        }
        else {
          setDetail(null);
        }
        setLoading(false);
      }
      else {
        handleLogout();
      }
    }
    catch(ex){
      setLoading(false);
      console.log('Error:',ex);
    }  
  }


  const getData = async() => {
    await loadProgram();
  }

  // Handle responsive detection
  const handleResize = () => {
    setIsMobile(isMobile);
  };

 
  useEffect(() => {
    getData();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [location]);

  // Tự mở section Recommendation Letters khi đã có data
  useEffect(() => {
    const letters = (detail?.programManager as any)?.recommendation_letters;
    if (Array.isArray(letters) && letters.length > 0) {
      setRecommendationLettersExpanded(true);
    }
  }, [detail?.programManager]);

  // Tự mở section Transcripts khi đã có data
  useEffect(() => {
    const transcripts = (detail?.programManager as any)?.transcripts;
    if (Array.isArray(transcripts) && transcripts.length > 0) {
      setTranscriptsExpanded(true);
    }
  }, [detail?.programManager]);

  // Tự mở section Resume khi đã có data
  useEffect(() => {
    const resume = (detail?.programManager as any)?.resume;
    if (Array.isArray(resume) && resume.length > 0) {
      setResumeExpanded(true);
    }
  }, [detail?.programManager]);

  // Tự mở section Essays khi đã có data
  useEffect(() => {
    const essays = (detail?.programManager as any)?.essays;
    if (Array.isArray(essays) && essays.length > 0) {
      setEssaysExpanded(true);
    }
  }, [detail?.programManager]);

  // Sync reminders from programManager (from API)
  useEffect(() => {
    const raw = (detail?.programManager as any)?.reminders;
    if (Array.isArray(raw)) {
      setReminders(
        raw.map((r: any) => ({
          title: r.title ?? '',
          dueDate: r.dueDate ?? r.due_date ?? '',
          notes: r.notes ?? '',
          complete: r.complete ?? false,
        }))
      );
    } else {
      setReminders([]);
    }
  }, [detail?.programManager]);

  // Sync program notes from programManager.metadata.notes (from API)
  // Format: split by ; or \n\n, display as numbered list "- 1", "- 2", "- 3"
  useEffect(() => {
    const raw = (detail?.programManager as any)?.metadata?.notes;
    if (raw == null) {
      setProgramNotes('');
      return;
    }
    const str = String(raw).replace(/\\n/g, '\n'); // unescape literal \n
    const items = str
      .split(/\s*;\s*|\n\s*\n+/)
      .map((s) => s.trim())
      .filter(Boolean);
    const formatted = items.length
      ? items.map((item) => `- ${item}`).join('\n')
      : str;
    setProgramNotes(formatted);
  }, [detail?.programManager]);

  const savedResourceLinks: SavedResourceLink[] = useMemo(() => {
    const raw = (detail?.programManager as any)?.metadata?.resourceLinks;
    return Array.isArray(raw) ? raw : [];
  }, [detail?.programManager]);

  const handleDeleteResourceLink = async (index: number) => {
    const mgrId = detail?.programManager?.id;
    if (mgrId == null) return;
    const pm = (detail?.programManager as any) ?? {};
    const meta = { ...(pm.metadata || {}) };
    const links = [...(Array.isArray(meta.resourceLinks) ? meta.resourceLinks : [])];
    if (index < 0 || index >= links.length) return;
    links.splice(index, 1);
    try {
      await userProgramsService.patchProgramsManager(mgrId, {
        metadata: { ...meta, resourceLinks: links },
      });
      setDetail((prev: any) => ({
        ...prev,
        programManager: {
          ...prev.programManager,
          metadata: {
            ...(prev.programManager?.metadata || {}),
            resourceLinks: links,
          },
        },
      }));
      toast.success('Link removed.');
    } catch {
      // interceptor
    }
  };

  const programNotesRef = useRef(programNotes);
  programNotesRef.current = programNotes;
  const programManagerId = detail?.programManager?.id;
  const debouncedSaveNotes = useMemo(
    () =>
      debounce(() => {
        const id = programManagerId;
        const notes = programNotesRef.current ?? '';
        if (id != null) {
          const pm = (detailRef.current?.programManager as any) ?? {};
          const meta = { ...(pm.metadata || {}) };
          userProgramsService
            .patchProgramsManager(id, { metadata: { ...meta, notes } })
            .catch(() => {
              // Error toast handled by http interceptor
            });
        }
      }, 500),
    [programManagerId]
  );
  useEffect(() => {
    debouncedSaveNotes();
    return () => debouncedSaveNotes.cancel();
  }, [programNotes, debouncedSaveNotes]);

  /** Application Deadline: form (Program Manager) first, then program listing fields */
  const getApplicationDeadlineFromForm = (d: any) => {
    const pm = d?.programManager as any;
    const app = pm?.application_form || {};
    const fromForm =
      app?.applicationDeadline ??
      app?.application_deadline ??
      app?.targetDate ??
      app?.target_date ??
      pm?.targetDate ??
      pm?.target_date ??
      '';
    return fromForm != null && String(fromForm).trim() !== '' ? String(fromForm).trim() : '';
  };

  const getApplicationDeadlineFromProgramDetail = (d: any) => {
    const v = (d?.applicationDeadline ?? d?.app_deadline) || d?.application_due;
    return v != null && String(v).trim() !== '' ? String(v).trim() : '';
  };

  // Sync applicationDeadline for date picker: form first, then program Key Dates fields
  useEffect(() => {
    userChangedDeadlineRef.current = false; // this is an API-driven sync, not a user action
    const fromForm = getApplicationDeadlineFromForm(detail);
    const fromProgram = getApplicationDeadlineFromProgramDetail(detail);
    setApplicationDeadline(fromForm || fromProgram);
  }, [
    detail?.programManager,
    detail?.applicationDeadline,
    detail?.app_deadline,
    detail?.application_due,
  ]);

  // Application Status (card): programManager.status — tách biệt application_form.status
  useEffect(() => {
    const pm = detail?.programManager as any;
    const v = String(pm?.status ?? '').trim();
    if (v === 'submitted' || v === 'completed') setManagerApplicationStatusUi('submitted');
    else if (v === 'in_progress') setManagerApplicationStatusUi('in_progress');
    else setManagerApplicationStatusUi(null);
  }, [detail?.programManager]);

  const applicationDeadlineRef = useRef(applicationDeadline);
  applicationDeadlineRef.current = applicationDeadline;
  // true only when the user explicitly picks a date; false when synced from API
  const userChangedDeadlineRef = useRef(false);

  const cascadeApplicationDeadline = useCallback(
    (pm: any, deadline: string, pmId: number) => {
      const patch: Record<string, unknown> = {};
      const transcripts = pm?.transcripts;
      if (Array.isArray(transcripts) && transcripts.length > 0) {
        patch.transcripts = transcripts.map((it: any) => ({
          type: it.type ?? 'official',
          status: it.status ?? 'not_started',
          date: deadline,
          link: it.link ?? it.quickLink,
          notes: it.notes,
        }));
      }
      const resume = pm?.resume;
      if (Array.isArray(resume) && resume.length > 0) {
        patch.resume = resume.map((it: any) => ({
          documentName: it.documentName ?? '',
          status: it.status ?? 'not_started',
          date: deadline,
          link: it.link ?? it.quickLink,
          notes: it.notes,
        }));
      }
      const essays = pm?.essays;
      if (Array.isArray(essays) && essays.length > 0) {
        patch.essays = essays.map((it: any) => ({
          title: it.title ?? '',
          prompt: it.prompt,
          status: it.status ?? 'not_started',
          targetDate: deadline,
          wordCount: it.wordCount,
          notes: it.notes,
          link: it.link ?? it.quickLink,
        }));
      }
      const letters = pm?.recommendation_letters;
      if (Array.isArray(letters) && letters.length > 0) {
        patch.recommendationLetters = letters.map((it: any) => ({
          firstName: it.firstName ?? '',
          lastName: it.lastName ?? '',
          subjectRelationship: it.subjectDepartment ?? it.subjectRelationship ?? '',
          email: it.email,
          status: it.status ?? 'not_started',
          date: deadline,
          link: it.link,
        }));
      }
      if (Object.keys(patch).length > 0) {
        return userProgramsService.patchProgramsManager(pmId, patch).then(() => patch);
      }
      return Promise.resolve(patch);
    },
    []
  );

  const debouncedSaveApplicationDeadline = useMemo(
    () =>
      debounce(() => {
        const id = programManagerId;
        const deadline = applicationDeadlineRef.current?.trim() ?? '';
        if (id == null) return;
        const pm = (detailRef.current?.programManager as any) ?? {};
        const app = { ...(pm?.application_form || {}), applicationDeadline: deadline };
        userProgramsService
          .patchProgramsManager(id, {
            applicationForm: {
              ...app,
              status: app.status ?? 'not_started',
              targetDate: deadline,
              link: app.link,
              notes: app.notes,
            },
          })
          .then(() => {
            toast.success('Application deadline saved.');
            setDetail((prev: any) => {
              if (!prev?.programManager) return prev;
              return {
                ...prev,
                programManager: {
                  ...prev.programManager,
                  application_form: {
                    ...(prev.programManager.application_form || {}),
                    applicationDeadline: deadline,
                    targetDate: deadline,
                  },
                },
              };
            });
            if (deadline) {
              cascadeApplicationDeadline(pm, deadline, id).then((patch: any) => {
                if (patch && Object.keys(patch).length > 0) {
                  setDetail((prev: any) => {
                    if (!prev?.programManager) return prev;
                    const updated = { ...prev.programManager };
                    if (patch.transcripts) updated.transcripts = patch.transcripts;
                    if (patch.resume) updated.resume = patch.resume;
                    if (patch.essays) updated.essays = patch.essays;
                    if (patch.recommendationLetters) updated.recommendation_letters = patch.recommendationLetters;
                    return { ...prev, programManager: updated };
                  });
                }
              });
            }
          })
          .catch(() => {});
      }, 500),
    [programManagerId, cascadeApplicationDeadline]
  );

  useEffect(() => {
    if (!userChangedDeadlineRef.current) return;
    debouncedSaveApplicationDeadline();
    return () => debouncedSaveApplicationDeadline.cancel();
  }, [applicationDeadline, debouncedSaveApplicationDeadline]);

  const handleApplicationStatusChange = useCallback(
    async (next: 'in_progress' | 'submitted') => {
      const id = programManagerId;
      if (id == null) return;

      const pm = (detailRef.current?.programManager as any) ?? {};
      const cur = String(pm.status ?? '').trim();
      const normalizedUi: 'in_progress' | 'submitted' | null =
        cur === 'submitted' || cur === 'completed' ? 'submitted' :
        cur === 'in_progress' ? 'in_progress' : null;
      if (next === normalizedUi) return;

      setManagerApplicationStatusUi(next);
      try {
        await userProgramsService.patchProgramsManager(id, { status: next });
        toast.success(`Status updated to ${next === 'in_progress' ? 'In Progress' : 'Submitted'}.`);
        setDetail((prev: any) => {
          if (!prev?.programManager) return prev;
          return {
            ...prev,
            programManager: {
              ...prev.programManager,
              status: next,
            },
          };
        });
      } catch {
        setManagerApplicationStatusUi(normalizedUi);
      }
    },
    [programManagerId]
  );

  const handleToggleReminderComplete = async (idx: number) => {
    const updated = reminders.map((r, i) =>
      i === idx ? { ...r, complete: !(r.complete ?? false) } : r
    );
    setReminders(updated);
    const pmId = detail?.programManager?.id;
    if (pmId != null) {
      try {
        await userProgramsService.patchProgramsManager(pmId, {
          reminders: updated.map((r) => ({
            title: r.title,
            dueDate: r.dueDate,
            notes: r.notes,
            complete: r.complete ?? false,
          })),
        });
      } catch {
        setReminders(reminders);
      }
    }
  };

  const handleDeleteReminder = async (idx: number) => {
    const updated = reminders.filter((_, i) => i !== idx);
    setReminders(updated);
    const pmId = detail?.programManager?.id;
    if (pmId != null) {
      try {
        await userProgramsService.patchProgramsManager(pmId, {
          reminders: updated.map((r) => ({
            title: r.title,
            dueDate: r.dueDate,
            notes: r.notes,
            complete: r.complete ?? false,
          })),
        });
        toast.success('Reminder deleted.');
      } catch {
        setReminders(reminders);
      }
    }
  };

  const displayValue = (v: any) => {
    const s = v == null ? '' : String(v).trim();
    return s.length > 0 ? s : '—';
  };

  /** Format eligibility as "Current high school student (grade x-x-x-x-x)" and parse eligibilityDetails */
  const getEligibilityItems = (d: any): string[] => {
    const eligibility = (d?.eligibility ?? '').trim();
    const eligibilityDetails = (d?.eligibilityDetails ?? d?.eligibility_details ?? '').trim();
    const gradePart = (d?.offerIn ?? d?.offer_in ?? d?.grades ?? '').trim();
    const items: string[] = [];
    // First line: eligibility + (grade x-x-x-x-x) when grade info exists
    if (eligibility) {
      const gradeSuffix = gradePart ? ` (grade ${String(gradePart).replace(/\s*,\s*/g, '-')})` : '';
      items.push(`${eligibility}${gradeSuffix}`);
    }
    // Remaining items from eligibilityDetails (split by newline, semicolon, or sentence breaks)
    if (eligibilityDetails) {
      const detailItems = String(eligibilityDetails)
        .split(/\n|;|\.(?=\s*[A-Z])/)
        .map((s: string) => s.trim())
        .filter((s: string) => s.length > 0);
      items.push(...detailItems);
    }
    // Fallback: legacy data only has eligibility|grades as combined string
    if (items.length === 0 && (d?.eligibility || d?.grades)) {
      return String(d?.eligibility || d?.grades)
        .split(/\n|;|\.(?=\s*[A-Z])/)
        .map((s: string) => s.trim())
        .filter((s: string) => s.length > 0);
    }
    return items;
  };

  const handleAddToProgramManager = async () => {
    if (!detail?.id) return;
    setIsAddingToManager(true);
    try {
      await userProgramsService.addToProgramsManager(detail.id);
      toast.success('Program added to Program Manager');
      await loadProgram();
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message || 'Failed to add program to Program Manager';
      toast.error(message);
    } finally {
      setIsAddingToManager(false);
    }
  };

  const handleApplicationFormSubmit = (values: { status: string; targetDate: string; link: string; notes: string }) => {
    setDetail((prev: any) => {
      if (!prev?.programManager) return prev;
      return {
        ...prev,
        programManager: {
          ...prev.programManager,
          application_form: {
            ...(prev.programManager.application_form || {}),
            status: values.status,
            targetDate: values.targetDate,
            link: values.link,
            notes: values.notes,
          },
        },
      };
    });
  };

  const infoItem = (label: string, value: any, secondary?: any) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '12px 0' }}>
      <div style={{ color: '#4b5563', fontSize: '15px', fontWeight: 600 }}>{label}</div>
      <div style={{ color: '#111827', fontSize: '16px', fontWeight: 600 }}>{displayValue(value)}</div>
      {secondary && (
        <div style={{ color: '#6b7280', fontSize: '14px' }}>{secondary}</div>
      )}
    </div>
  );

  const overviewItem = (label: string, value: any) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <div style={{ color: '#111827', fontSize: '14px' }}>{label}</div>
      <div style={{ color: '#111827', fontSize: '16px', fontWeight: 600 }}>{displayValue(value)}</div>
    </div>
  );

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', padding: isMobile ? '12px' : '24px' }}>
      <Container style={{ maxWidth: '1180px', padding: 0 }}>
        {loading ? (
          <LoadingContent />
        ) : (
          <>
            {/* Header card: title, institution, Visit Website, tags, and key details in one card */}
            <div
              style={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                padding: isMobile ? '16px' : '24px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                border: '1px solid #e5e7eb',
                marginBottom: '16px'
              }}
            >
              {/* Row 1: Title (left) + Open Quick View Drawer (right) - blue filled button */}
              <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: isMobile ? 'stretch' : 'flex-start', gap: '12px', marginBottom: '12px' }}>
                <h1 style={{ margin: 0, fontSize: isMobile ? '24px' : '28px', color: '#111827', fontWeight: 700 }}>
                  {(detail?.programName ?? detail?.program_name) || detail?.post_title || ''}
                </h1>
                {/* <button
                  type="button"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: 'none',
                    backgroundColor: '#2563eb',
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Open Quick View Drawer <OpenInFullIcon sx={{ fontSize: '18px' }} />
                </button> */}
              </div>

              {/* Institution name */}
              <div style={{ color: '#111827', fontSize: '16px', marginBottom: '12px' }}>
                {displayValue(detail?.institution || detail?.post_author_name)}
              </div>

              {/* Visit Website - blue filled button */}
              {detail?.website && (
                <a
                  href={detail.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: '#2563eb',
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: 600,
                    textDecoration: 'none',
                    marginBottom: '12px'
                  }}
                >
                  Visit Website <OpenInNewIcon sx={{ fontSize: '18px' }} />
                </a>
              )}

              {/* Tags - blue, underlined (link style) */}
              <div style={{ marginBottom: '20px' }}>
                {(categories || []).length > 0
                  ? categories.map((c: string, idx: number) => (
                      <span
                        key={`${c}-${idx}`}
                        style={{
                          color: '#2563eb',
                          fontSize: '14px',
                          textDecoration: 'underline',
                          cursor: 'pointer'
                        }}
                      >
                        {c}{idx < categories.length - 1 ? ', ' : ''}
                      </span>
                    ))
                  : <span style={{ color: '#6b7280', fontSize: '14px' }}>—</span>}
              </div>

              {/* Key details: one row - City, Duration, State/Province, Country, Cost */}
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(5, 1fr)', columnGap: '24px', rowGap: '16px' }}>
                {overviewItem('City', detail?.city)}
                {overviewItem('Duration', formatDurationWeeks(detail?.duration))}
                {overviewItem('State/Province', detail?.stateProvince ?? detail?.state_province)}
                {overviewItem('Country', detail?.country)}
                {overviewItem(
                  'Cost',
                  detail?.cost ??
                    (((detail?.costMin ?? detail?.cost_min) != null || (detail?.costMax ?? detail?.cost_max) != null)
                      ? [(detail?.costMin ?? detail?.cost_min), (detail?.costMax ?? detail?.cost_max)]
                          .filter((v: any) => v != null && String(v).trim() !== '')
                          .join(' - ')
                      : '')
                )}
              </div>
            </div>

            {/* Two columns: Trái (Program Information + Key Dates + Eligibility) | Phải (Application Requirements) — trái rộng hơn */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'minmax(0, 1.5fr) minmax(0, 1fr)',
                gap: '16px',
                marginBottom: '16px'
              }}
            >
              {/* Cột trái: Program Information, Key Dates, Eligibility */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {/* Program Information */}
              <div
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  padding: isMobile ? '16px' : '24px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  border: '1px solid #e5e7eb'
                }}
              >
                <h2 style={{ margin: 0, marginBottom: '20px', fontSize: '22px', color: '#111827', fontWeight: 700 }}>Program Information</h2>

                {/* Primary Category & Sub-Category - side by side */}
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '24px', paddingBottom: '16px', borderBottom: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div>
                    <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Primary Category</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#111827', fontSize: '16px', fontWeight: 600 }}>
                      <ScienceIcon sx={{ fontSize: '20px', color: '#111827' }} />
                      {displayValue(detail?.primaryCategory ?? detail?.primary_category)}
                    </div>
                  </div>
                  <div>
                    <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Sub-Category</div>
                    <div style={{ color: '#111827', fontSize: '16px', fontWeight: 600 }}>{displayValue(detail?.subCategory ?? detail?.sub_category)}</div>
                  </div>
                </div>

                {/* Program Tags */}
                <div style={{ paddingBottom: '16px', borderBottom: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div style={{ color: '#111827', fontSize: '14px', marginBottom: '8px' }}>Program Tags</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 8px' }}>
                    {(categories || []).length > 0
                      ? categories.map((c: string, idx: number) => (
                          <span key={`tag-${c}-${idx}`} style={{ color: '#2563eb', fontSize: '14px', fontWeight: 500, cursor: 'pointer' }}>
                            {c}{idx < categories.length - 1 ? ',' : ''}
                          </span>
                        ))
                      : <span style={{ color: '#6b7280', fontSize: '14px' }}>—</span>}
                  </div>
                </div>

                {/* Program Delivery & Residential Option - side by side */}
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '24px', paddingBottom: '16px', borderBottom: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div>
                    <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Program Delivery</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#111827', fontSize: '16px', fontWeight: 600 }}>
                      <LocationOnIcon sx={{ fontSize: '20px', color: '#111827' }} />
                      {displayValue((detail?.programDelivery ?? detail?.program_delivery) || detail?.format)}
                    </div>
                  </div>
                  <div>
                    <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Residential Option</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#111827', fontSize: '16px', fontWeight: 600 }}>
                      <HomeWorkIcon sx={{ fontSize: '20px', color: '#111827' }} />
                      {displayValue(detail?.residentialOption ?? detail?.residential_option)}
                    </div>
                  </div>
                </div>

                {/* Eligibility */}
                <div style={{ paddingBottom: '16px', borderBottom: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Eligibility</div>
                  <div style={{ color: '#374151', fontSize: '15px', lineHeight: 1.5 }}>
                    {(() => {
                      const items = getEligibilityItems(detail);
                      return items.length > 0
                        ? items.map((item, idx) => (
                            <div key={idx} style={{ marginBottom: idx > 0 ? '8px' : 0 }}>{item}</div>
                          ))
                        : displayValue(detail?.eligibility || detail?.grades);
                    })()}
                  </div>
                </div>

                {/* Program Dates */}
                <div style={{ paddingBottom: '16px', borderBottom: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Program Dates</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#111827', fontSize: '16px', fontWeight: 600 }}>
                    <CalendarMonthIcon sx={{ fontSize: '20px', color: '#111827' }} />
                    {displayValue(detail?.programDates ?? detail?.program_dates)}
                  </div>
                </div>

                {/* Duration */}
                <div style={{ paddingBottom: '16px', borderBottom: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Duration</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#111827', fontSize: '16px', fontWeight: 600 }}>
                    <AccessTimeIcon sx={{ fontSize: '20px', color: '#111827' }} />
                    {displayValue(formatDurationWeeks(detail?.duration))}
                  </div>
                </div>

                {/* Cost - label above, green box with icon + main text + secondary */}
                <div style={{ paddingBottom: '16px', borderBottom: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div style={{ color: '#111827', fontSize: '14px', marginBottom: '8px' }}>Cost</div>
                  {((detail?.costMin ?? detail?.cost_min) != null || (detail?.costMax ?? detail?.cost_max) != null || detail?.cost || detail?.stipend) ? (
                    <div
                      style={{
                        backgroundColor: '#ecfdf5',
                        border: '1px solid #a7f3d0',
                        borderRadius: '8px',
                        padding: '16px'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#065f46', fontSize: '18px', fontWeight: 700 }}>
                        <AttachMoneyIcon sx={{ fontSize: '22px' }} />
                        {detail?.stipend
                          ? `$${detail.stipend} Stipend`
                          : detail?.cost ??
                            [(detail?.costMin ?? detail?.cost_min), (detail?.costMax ?? detail?.cost_max)]
                              .filter((v: any) => v != null && String(v).trim() !== '')
                              .join(' - ')}
                      </div>
                      {((detail?.stipendNote ?? detail?.stipend_note) || (detail?.costNote ?? detail?.cost_note)) && (
                        <div style={{ color: '#047857', fontSize: '14px', marginTop: '6px' }}>
                          {(detail?.stipendNote ?? detail?.stipend_note) || (detail?.costNote ?? detail?.cost_note)}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ color: '#111827', fontSize: '16px', fontWeight: 600 }}>—</div>
                  )}
                </div>

                {/* Multi-Program Family & Parent Program - side by side */}
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '24px', paddingBottom: '16px', borderBottom: '1px solid #e5e7eb', marginBottom: '16px' }}>
                  <div>
                    <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Multi-Program Family</div>
                    <div style={{ color: '#111827', fontSize: '16px', fontWeight: 600 }}>{displayValue(detail?.multiProgramFamily ?? detail?.multi_program_family)}</div>
                  </div>
                  <div>
                    <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Parent Program</div>
                    <div style={{ color: '#111827', fontSize: '16px', fontWeight: 600 }}>{displayValue((detail?.parentProgramName ?? detail?.parent_program_name) || detail?.parent_program) || 'N/A'}</div>
                  </div>
                </div>

                {/* Program Description */}
                <div>
                  <div style={{ color: '#111827', fontSize: '14px', marginBottom: '6px' }}>Program Notes</div>
                  <div style={{ color: '#374151', fontSize: '15px', lineHeight: 1.5 }}>
                    {(() => {
                      const raw = detail?.notes;
                      if (raw == null || String(raw).trim() === '') return '—';
                      const str = String(raw).replace(/\\n/g, '\n');
                      const items = str
                        .split(/\s*;\s*|\n\s*\n+/)
                        .map((s: string) => s.trim())
                        .filter(Boolean);
                      const formatted = items.length
                        ? items.map((item) => `- ${item}`).join('\n')
                        : str;
                      return (
                        <span style={{ whiteSpace: 'pre-wrap' }}>{formatted}</span>
                      );
                    })()}
                  </div>
                </div>
              </div>

              {/* Key Dates card - cột trái */}
              <div
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  padding: isMobile ? '16px' : '24px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  border: '1px solid #e5e7eb',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                  <CalendarMonthIcon sx={{ fontSize: '24px', color: '#2563eb' }} />
                  <h2 style={{ margin: 0, fontSize: '20px', color: '#111827', fontWeight: 700 }}>Key Dates</h2>
                </div>
                <div>
                  {[
                    { label: 'Application Open', value: (detail?.applicationOpenIn ?? detail?.app_open_date) || detail?.application_open_date, highlight: false },
                    {
                      label: 'Application Deadline',
                      value:
                        applicationDeadline?.trim() ||
                        getApplicationDeadlineFromForm(detail) ||
                        getApplicationDeadlineFromProgramDetail(detail) ||
                        '',
                      highlight: true,
                    },
                    { label: 'Program Dates', value: detail?.programDates ?? detail?.program_dates, highlight: false },
                    { label: 'Decision Release', value: (detail?.decisionRelease ?? detail?.decision_release) || detail?.decision_release_date, highlight: false },
                  ].map((row, idx) => (
                    <div
                      key={row.label}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 0',
                        borderBottom: idx < 3 ? '1px solid #e5e7eb' : 'none',
                        gap: '16px',
                      }}
                    >
                      <span style={{ color: '#6b7280', fontSize: '15px' }}>{row.label}</span>
                      <span
                        style={{
                          color: row.highlight ? '#dc2626' : '#111827',
                          fontSize: '15px',
                          fontWeight: row.highlight ? 700 : 500,
                          textAlign: 'right',
                        }}
                      >
                        {displayValue(row.value)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Eligibility card - cột trái */}
              <div
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  padding: isMobile ? '16px' : '24px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  border: '1px solid #e5e7eb',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                  <PersonOutlineIcon sx={{ fontSize: '24px', color: '#2563eb' }} />
                  <h2 style={{ margin: 0, fontSize: '20px', color: '#111827', fontWeight: 700 }}>Eligibility</h2>
                </div>
                <ul style={{ margin: 0, paddingLeft: 0, listStyle: 'none' }}>
                  {(() => {
                    const eligibilityItems = getEligibilityItems(detail);
                    return eligibilityItems.length > 0
                      ? eligibilityItems.map((item: string, idx: number) => (
                          <li
                            key={idx}
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: '10px',
                              marginBottom: '10px',
                              fontSize: '15px',
                              color: '#111827',
                            }}
                          >
                            <CheckCircleIcon sx={{ fontSize: '20px', color: '#16a34a', flexShrink: 0, mt: '2px' }} />
                            <span>{item}</span>
                          </li>
                        ))
                      : (
                          <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '15px', color: '#6b7280' }}>
                            <CheckCircleIcon sx={{ fontSize: '20px', color: '#16a34a', flexShrink: 0 }} />
                            <span>—</span>
                          </li>
                        );
                  })()}
                </ul>
              </div>

              {/* Requirements Snapshot card */}
              <div
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  padding: isMobile ? '16px' : '24px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  border: '1px solid #e5e7eb',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                  <AssignmentIcon sx={{ fontSize: '24px', color: '#2563eb' }} />
                  <h2 style={{ margin: 0, fontSize: '20px', color: '#111827', fontWeight: 700 }}>Requirements Snapshot</h2>
                </div>
                <div>
                  {[
                    { label: 'Application Form', status: 'Required', statusColor: '#dc2626' },
                    { label: 'Recommendations', status: (detail?.generalRecommendationsCount ?? detail?.general_recommendations) || (detail?.teacherRecommendationsCount ?? detail?.teacher_recommendations) ? '2 Required' : 'Required', statusColor: '#dc2626' },
                    { label: 'Transcripts', status: detail?.transcriptRequired === 'Yes' || detail?.transcriptRequired === true || detail?.transcript_required === 'Yes' || detail?.transcript_required === true ? 'Yes' : 'Yes', statusColor: '#16a34a' },
                    { label: 'Resume', status: 'Yes', statusColor: '#16a34a' },
                    { label: 'Essays', status: (detail?.essaysCount ?? detail?.essays_count) ? `${detail?.essaysCount ?? detail?.essays_count} Essays` : '2 Essays', statusColor: '#111827' },
                  ].map((row, idx) => (
                    <div
                      key={row.label}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 0',
                        borderBottom: idx < 4 ? '1px solid #e5e7eb' : 'none',
                        gap: '16px',
                      }}
                    >
                      <span style={{ color: '#111827', fontSize: '15px' }}>{row.label}</span>
                      <span style={{ color: row.statusColor, fontSize: '15px', fontWeight: 500 }}>{row.status}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Resource Links card */}
              <div
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  padding: isMobile ? '16px' : '24px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  border: '1px solid #e5e7eb',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <LinkIcon sx={{ fontSize: '24px', color: '#2563eb' }} />
                    <h2 style={{ margin: 0, fontSize: '20px', color: '#111827', fontWeight: 700 }}>Resource Links</h2>
                  </div>
                  {!isTrial && (
                    <button
                      type="button"
                      onClick={() => setResourceLinkFormOpen((open) => !open)}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '8px 14px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#2563eb',
                        color: '#fff',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer',
                      }}
                    >
                      <AddIcon sx={{ fontSize: '18px' }} /> Add Resource Link
                    </button>
                  )}
                </div>
                {resourceLinkFormOpen && !isTrial && (
                  <ResourceLinkFormDropdown
                    programManagerId={detail?.programManager?.id}
                    existingMetadata={((detail?.programManager as any)?.metadata ?? {}) as Record<string, unknown>}
                    currentLinks={savedResourceLinks}
                    onClose={() => setResourceLinkFormOpen(false)}
                    onSaved={(list) => {
                      setDetail((prev: any) => ({
                        ...prev,
                        programManager: {
                          ...prev.programManager,
                          metadata: {
                            ...(prev.programManager?.metadata || {}),
                            resourceLinks: list,
                          },
                        },
                      }));
                    }}
                  />
                )}
                <div>
                  {[
                    { label: 'Program Website', icon: <LanguageIcon sx={{ fontSize: '20px', color: '#2563eb' }} />, url: detail?.website },
                    { label: 'Application Portal', icon: <DescriptionIcon sx={{ fontSize: '20px', color: '#2563eb' }} />, url: (detail?.applicationPortal ?? detail?.application_portal) || detail?.application_url },
                  ].map((row, idx) => {
                    const totalRows = 2 + savedResourceLinks.length;
                    const rowIndex = idx;
                    return (
                    <div
                      key={row.label}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '12px 0',
                        borderBottom: rowIndex < totalRows - 1 ? '1px solid #e5e7eb' : 'none',
                        gap: '12px',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
                        {row.icon}
                        <span style={{ color: '#111827', fontSize: '15px' }}>{row.label}</span>
                      </div>
                      <a
                        href={row.url || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          padding: '6px 12px',
                          borderRadius: '6px',
                          color: row.url ? '#2563eb' : '#9ca3af',
                          fontSize: '14px',
                          fontWeight: 600,
                          cursor: row.url ? 'pointer' : 'default',
                          textDecoration: 'none',
                        }}
                        onClick={(e) => !row.url && e.preventDefault()}
                      >
                        Open
                      </a>
                    </div>
                    );
                  })}
                  {savedResourceLinks.map((link, idx) => {
                    const totalRows = 2 + savedResourceLinks.length;
                    const rowIndex = 2 + idx;
                    const label = link.label || link.typeKey;
                    const hrefOk = link.url && isValidHttpOrHttpsUrl(link.url);
                    const href = hrefOk ? normalizeResourceUrl(link.url) : '';
                    return (
                      <div
                        key={`metadata-resource-link-${idx}-${link.typeKey}`}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '12px 0',
                          borderBottom: rowIndex < totalRows - 1 ? '1px solid #e5e7eb' : 'none',
                          gap: '12px',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
                          <LinkIcon sx={{ fontSize: '20px', color: '#2563eb', flexShrink: 0 }} />
                          <span style={{ color: '#111827', fontSize: '15px' }}>{label}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                          {hrefOk ? (
                            <a
                              href={href}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '6px 12px',
                                borderRadius: '6px',
                                backgroundColor: '#2563eb',
                                color: '#fff',
                                fontSize: '14px',
                                fontWeight: 600,
                                textDecoration: 'none',
                              }}
                            >
                              <LinkIcon sx={{ fontSize: '16px' }} />
                              View Link
                            </a>
                          ) : (
                            <span style={{ fontSize: '13px', color: '#9ca3af', fontWeight: 500 }}>Invalid link</span>
                          )}
                          <button
                            type="button"
                            onClick={() => handleDeleteResourceLink(idx)}
                            aria-label="Remove link"
                            style={{
                              padding: '6px',
                              border: 'none',
                              background: 'transparent',
                              cursor: 'pointer',
                              color: '#9ca3af',
                              display: 'inline-flex',
                            }}
                          >
                            <DeleteOutlineIcon sx={{ fontSize: '22px' }} />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Personal Reminders card - only when !isTrial */}
              {!isTrial && (
              <div
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  padding: isMobile ? '16px' : '24px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  border: '1px solid #e5e7eb',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <NotificationsActiveIcon sx={{ fontSize: '24px', color: '#2563eb' }} />
                    <h2 style={{ margin: 0, fontSize: '20px', color: '#111827', fontWeight: 700 }}>Personal Reminders</h2>
                  </div>
                  <button
                    type="button"
                    onClick={() => setReminderFormOpen(true)}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '8px 14px',
                      borderRadius: '8px',
                      border: 'none',
                      backgroundColor: '#2563eb',
                      color: '#fff',
                      fontSize: '14px',
                      fontWeight: 600,
                      cursor: 'pointer',
                    }}
                  >
                    <AddIcon sx={{ fontSize: '18px' }} /> Add Reminder
                  </button>
                </div>
                {reminderFormOpen && (
                  <ReminderFormDropdown
                    programManagerId={detail?.programManager?.id}
                    currentReminders={reminders}
                    onClose={() => setReminderFormOpen(false)}
                    onSaved={(list) => setReminders(list)}
                    onSubmit={async (values) => {
                      if (detail?.programManager?.id == null) setReminders((prev) => [...prev, values]);
                    }}
                  />
                )}
                <p style={{ margin: '0 0 16px', fontSize: '13px', color: '#6b7280', lineHeight: 1.5 }}>
                  Reminders appear in your GradMap Notifications + My Summer Plan.
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {reminders.length === 0 ? (
                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>No reminders yet.</p>
                  ) : (
                    reminders.map((reminder, idx) => {
                      const dueDisplay = reminder.dueDate
                        ? new Date(reminder.dueDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
                        : '';
                      const isComplete = reminder.complete === true;
                      return (
                        <div
                          key={idx}
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '12px',
                            padding: '12px 16px',
                            backgroundColor: '#f3f4f6',
                            borderRadius: '8px',
                            border: '1px solid #e5e7eb',
                          }}
                        >
                          <Checkbox
                            checked={isComplete}
                            onChange={() => handleToggleReminderComplete(idx)}
                            sx={{
                              padding: 0,
                              marginTop: '2px',
                              '& .MuiSvgIcon-root': { fontSize: 22 },
                              color: '#9ca3af',
                              '&.Mui-checked': { color: '#16a34a' },
                            }}
                          />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
                              <div
                                style={{
                                  color: isComplete ? '#9ca3af' : '#111827',
                                  fontSize: '15px',
                                  fontWeight: 500,
                                  textDecoration: isComplete ? 'line-through' : 'none',
                                }}
                              >
                                {reminder.title || 'Untitled reminder'}
                              </div>
                              <span
                                style={{
                                  fontSize: '11px',
                                  fontWeight: 500,
                                  padding: '2px 8px',
                                  borderRadius: '9999px',
                                  backgroundColor: isComplete ? '#dcfce7' : '#fef3c7',
                                  color: isComplete ? '#16a34a' : '#d97706',
                                }}
                              >
                                {isComplete ? 'Complete' : 'Incomplete'}
                              </span>
                            </div>
                            {dueDisplay && (
                              <div style={{ color: '#6b7280', fontSize: '13px' }}>Due: {dueDisplay}</div>
                            )}
                            {reminder.notes && (
                              <div style={{ color: '#6b7280', fontSize: '13px', marginTop: '4px' }}>
                                {reminder.notes}
                              </div>
                            )}
                          </div>
                          <button
                            type="button"
                            onClick={() => setDeleteReminderIdx(idx)}
                            style={{
                              background: 'none',
                              border: 'none',
                              padding: '4px',
                              cursor: 'pointer',
                              color: '#dc2626',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            title="Delete reminder"
                            aria-label="Delete reminder"
                          >
                            <DeleteOutlineIcon sx={{ fontSize: '20px' }} />
                          </button>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
              )}

              {/* Notes card - only when !isTrial */}
              {!isTrial && (
              <div
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  padding: isMobile ? '16px' : '24px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  border: '1px solid #e5e7eb',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                  <NoteAddOutlinedIcon sx={{ fontSize: '24px', color: '#2563eb' }} />
                  <h2 style={{ margin: 0, fontSize: '20px', color: '#111827', fontWeight: 700 }}>Notes</h2>
                </div>
                <textarea
                  value={programNotes}
                  onChange={(e) => setProgramNotes(e.target.value.replace(/;/g, '\n'))}
                  placeholder="Add your personal notes about this program..."
                  rows={5}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: '1px solid #e5e7eb',
                    fontSize: '15px',
                    color: '#111827',
                    resize: 'vertical',
                    boxSizing: 'border-box',
                    whiteSpace: 'pre-wrap',
                  }}
                />
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '10px' }}>
                  <CheckCircleIcon sx={{ fontSize: '18px', color: '#16a34a' }} />
                  <span style={{ fontSize: '13px', color: '#6b7280' }}>Auto-saved</span>
                </div>
              </div>
              )}
              </div>

              {/* Cột phải: Application Requirements hoặc Add to Program Manager */}
              <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: '12px', alignSelf: 'flex-start' }}>
                {!isTrial && detail && detail.addManager !== true ? (
                  /* Chưa có trong Program Manager: chỉ hiển thị nút Add to Program Manager */
                  <div
                    style={{
                      padding: isMobile ? '14px 16px' : '24px',
                      backgroundColor: '#fff',
                      borderRadius: '12px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      border: '1px solid #e5e7eb',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '16px',
                      minHeight: '200px',
                    }}
                  >
                    <span style={{ color: '#374151', fontSize: '15px', textAlign: 'center' }}>
                      Add this program to your Program Manager to track applications, deadlines, and requirements.
                    </span>
                    <button
                      type="button"
                      disabled={isAddingToManager}
                      onClick={handleAddToProgramManager}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#2563eb',
                        color: '#fff',
                        fontSize: '15px',
                        fontWeight: 600,
                        cursor: isAddingToManager ? 'wait' : 'pointer',
                        opacity: isAddingToManager ? 0.8 : 1,
                      }}
                    >
                      <AddIcon sx={{ fontSize: '20px' }} />
                      {isAddingToManager ? 'Adding...' : 'Add to Program Manager'}
                    </button>
                  </div>
                ) : (
                  <>
                {/* Application Deadline - trên cùng, ngoài tất cả các form */}
                <div
                  style={{
                    padding: isMobile ? '14px 16px' : '16px 20px',
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    border: '1px solid #e5e7eb',
                    marginBottom: '12px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      alignItems: isMobile ? 'stretch' : 'center',
                      justifyContent: 'space-between',
                      gap: '12px',
                      marginBottom: '10px',
                    }}
                  >
                    <span style={{ color: '#111827', fontSize: '15px', fontWeight: 600, flexShrink: 0 }}>
                      Application Deadline
                    </span>
                    <DatePicker
                      value={
                        applicationDeadline?.trim() && moment(applicationDeadline).isValid()
                          ? moment(applicationDeadline)
                          : null
                      }
                      onChange={(val) => {
                        userChangedDeadlineRef.current = true;
                        setApplicationDeadline(
                          val && moment(val).isValid() ? moment(val).format('YYYY-MM-DD') : ''
                        );
                      }}
                      inputFormat="MM/DD/yyyy"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          placeholder="MM/DD/yyyy"
                          sx={{
                            alignSelf: isMobile ? 'stretch' : 'flex-end',
                            width: isMobile ? '100%' : 'auto',
                            minWidth: isMobile ? undefined : 200,
                            maxWidth: 220,
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              backgroundColor: '#f9fafb',
                            },
                            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e5e7eb' },
                          }}
                        />
                      )}
                    />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
                    <CheckCircleIcon sx={{ fontSize: '18px', color: '#16a34a' }} />
                    <span style={{ fontSize: '13px', color: '#6b7280' }}>Auto-saved • Cascades to all forms</span>
                  </div>
                </div>

                {/* Application Status */}
                <div
                  style={{
                    padding: isMobile ? '14px 16px' : '16px 20px',
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    border: '1px solid #e5e7eb',
                    marginBottom: '12px',
                  }}
                >
                  <div
                    style={{
                      color: '#111827',
                      fontSize: '15px',
                      fontWeight: 600,
                      marginBottom: '12px',
                    }}
                  >
                    Application Status
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    {(
                      [
                        { value: 'in_progress', label: 'In Progress', activeColor: '#2563eb' },
                        { value: 'submitted', label: 'Submitted', activeColor: '#16a34a' },
                      ] as Array<{ value: 'in_progress' | 'submitted'; label: string; activeColor: string }>
                    ).map(({ value, label, activeColor }) => {
                      const isActive = managerApplicationStatusUi === value;
                      return (
                        <button
                          key={value}
                          type="button"
                          disabled={isActive}
                          onClick={() => handleApplicationStatusChange(value)}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '8px 16px',
                            borderRadius: '8px',
                            border: isActive ? 'none' : '1px solid #d1d5db',
                            backgroundColor: isActive ? activeColor : '#f9fafb',
                            color: isActive ? '#fff' : '#6b7280',
                            fontSize: '15px',
                            fontWeight: 600,
                            cursor: isActive ? 'default' : 'pointer',
                          }}
                        >
                          {label}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Card 1: Application Form - có data thì luôn hiển thị form; chưa có data thì nút Add, click mới mở form */}
                <div>
                  {(() => {
                    const pm = detail?.programManager as any;
                    const app = pm?.application_form || {};
                    const hasApplicationFormData = !!(
                      pm &&
                      (app.applicationDeadline ??
                        app.application_deadline ??
                        app.targetDate ??
                        app.target_date ??
                        pm.targetDate ??
                        pm.target_date ??
                        app.notes ??
                        pm.notes ??
                        app.link ??
                        pm.link ??
                        app.status != null)
                    );
                    const showForm = hasApplicationFormData || applicationFormExpanded;
                    return (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: showForm ? undefined : 'space-between',
                            padding: isMobile ? '14px 16px' : '16px 20px',
                            backgroundColor: '#fff',
                            borderRadius: showForm ? '12px 12px 0 0' : '12px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                            border: '1px solid #e5e7eb',
                            borderBottom: showForm ? 'none' : undefined,
                          }}
                        >
                          <span style={{ color: '#111827', fontSize: '15px', fontWeight: 500 }}>
                            1. Application Form
                          </span>
                          {!hasApplicationFormData && !applicationFormExpanded && (
                            <button
                              type="button"
                              onClick={() => setApplicationFormExpanded(true)}
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '8px 16px',
                                borderRadius: '8px',
                                border: 'none',
                                backgroundColor: '#2563eb',
                                color: '#fff',
                                fontSize: '14px',
                                fontWeight: 600,
                                cursor: 'pointer',
                              }}
                            >
                              <AddIcon sx={{ fontSize: '18px' }} /> Add Application Form
                            </button>
                          )}
                        </div>
                        {showForm && (
                          <ApplicationFormDropdown
                            key={detail?.programManager?.id ?? 'new'}
                            programManagerId={detail?.programManager?.id}
                            initialValues={(() => {
                              const p = detail?.programManager as any;
                              const a = p?.application_form || {};
                              return {
                                status: a.status ?? 'not_started',
                                targetDate:
                                  a.targetDate ?? a.target_date ?? p?.targetDate ?? p?.target_date ?? '',
                                link: a.link ?? p?.link ?? '',
                                notes: a.notes ?? p?.notes ?? '',
                              };
                            })()}
                            onClose={() => setApplicationFormExpanded(false)}
                            onSubmit={(values) => {
                              handleApplicationFormSubmit(values);
                              setApplicationFormExpanded(false);
                            }}
                          />
                        )}
                      </>
                    );
                  })()}
                </div>
                {/* Card 2: Recommendation Letters - bấm mở form sổ xuống, array có thể thêm/xóa */}
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: isMobile ? '14px 16px' : '16px 20px',
                      backgroundColor: '#fff',
                      borderRadius: recommendationLettersExpanded ? '12px 12px 0 0' : '12px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      border: '1px solid #e5e7eb'
                    }}
                  >
                    <span style={{ color: '#111827', fontSize: '15px', fontWeight: 500 }}>
                      2. Recommendation Letters
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        setRecommendationLettersExpanded(true);
                        setAddLetterTrigger((t) => t + 1);
                      }}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#2563eb',
                        color: '#fff',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      <AddIcon sx={{ fontSize: '18px' }} /> Add Letters
                    </button>
                  </div>
                  {recommendationLettersExpanded && (
                    <RecommendationLettersDropdown
                      key={`recommendation-letters-${detail?.programManager?.id ?? 'none'}`}
                      programManagerId={detail?.programManager?.id}
                      applicationDeadline={applicationDeadline}
                      initialItems={(() => {
                        const letters = (detail?.programManager as any)?.recommendation_letters;
                        const a = (detail?.programManager as any)?.application_form || {};
                        const appDeadline = applicationDeadline || (a.applicationDeadline ?? a.application_deadline ?? a.targetDate ?? '');
                        if (!Array.isArray(letters) || letters.length === 0) return undefined;
                        return letters.map((it: any, index: number): RecommendationLetterItem => ({
                          id: it.id ?? `letter-${index}-${detail?.programManager?.id ?? index}`,
                          firstName: it.firstName ?? '',
                          lastName: it.lastName ?? '',
                          subjectDepartment: it.subjectRelationship ?? it.subjectDepartment ?? '',
                          email: it.email ?? '',
                          status: it.status ?? 'not_started',
                          targetDate: it.date ?? it.targetDate ?? appDeadline ?? '',
                          link: it.link ?? '',
                        }));
                      })()}
                      addLetterTrigger={addLetterTrigger}
                      onClose={() => setRecommendationLettersExpanded(false)}
                      onSubmit={(items) => {
                        console.log('Recommendation letters submitted:', items);
                      }}
                    />
                  )}
                </div>
                {/* Card 3: Transcripts - bấm "+ Add Transcripts" mở dropdown và thêm 1 transcript */}
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: isMobile ? '14px 16px' : '16px 20px',
                      backgroundColor: '#fff',
                      borderRadius: transcriptsExpanded ? '12px 12px 0 0' : '12px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      border: '1px solid #e5e7eb'
                    }}
                  >
                    <span style={{ color: '#111827', fontSize: '15px', fontWeight: 500 }}>
                      3. Transcripts
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        setTranscriptsExpanded(true);
                        setAddTranscriptTrigger((t) => t + 1);
                      }}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#2563eb',
                        color: '#fff',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      <AddIcon sx={{ fontSize: '18px' }} /> Add Transcripts
                    </button>
                  </div>
                  {transcriptsExpanded && (
                    <TranscriptsDropdown
                      key={`transcripts-${detail?.programManager?.id ?? 'none'}`}
                      programManagerId={detail?.programManager?.id}
                      applicationDeadline={applicationDeadline}
                      initialItems={(() => {
                        const list = (detail?.programManager as any)?.transcripts;
                        const a = (detail?.programManager as any)?.application_form || {};
                        const appDeadline = applicationDeadline || (a.applicationDeadline ?? a.application_deadline ?? a.targetDate ?? '');
                        if (!Array.isArray(list) || list.length === 0) return undefined;
                        return list.map((it: any, index: number): TranscriptItem => ({
                          id: it.id ?? `transcript-${index}-${detail?.programManager?.id ?? index}`,
                          type: it.type ?? 'official',
                          status: it.status ?? 'not_started',
                          targetDate: it.date ?? it.targetDate ?? appDeadline ?? '',
                          quickLink: it.link ?? it.quickLink ?? '',
                          notes: it.notes ?? '',
                        }));
                      })()}
                      addTranscriptTrigger={addTranscriptTrigger}
                      onClose={() => setTranscriptsExpanded(false)}
                      onSubmit={(items) => {
                        console.log('Transcripts submitted:', items);
                      }}
                    />
                  )}
                </div>
                {/* Card 4: Resume - bấm "+ Add Resume" mở dropdown và thêm 1 resume */}
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: isMobile ? '14px 16px' : '16px 20px',
                      backgroundColor: '#fff',
                      borderRadius: resumeExpanded ? '12px 12px 0 0' : '12px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      border: '1px solid #e5e7eb'
                    }}
                  >
                    <span style={{ color: '#111827', fontSize: '15px', fontWeight: 500 }}>
                      4. Resume
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        setResumeExpanded(true);
                        setAddResumeTrigger((t) => t + 1);
                      }}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#2563eb',
                        color: '#fff',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      <AddIcon sx={{ fontSize: '18px' }} /> Add Resume
                    </button>
                  </div>
                  {resumeExpanded && (
                    <ResumeDropdown
                      key={`resume-${detail?.programManager?.id ?? 'none'}`}
                      programManagerId={detail?.programManager?.id}
                      applicationDeadline={applicationDeadline}
                      initialItems={(() => {
                        const list = (detail?.programManager as any)?.resume;
                        const a = (detail?.programManager as any)?.application_form || {};
                        const appDeadline = applicationDeadline || (a.applicationDeadline ?? a.application_deadline ?? a.targetDate ?? '');
                        if (!Array.isArray(list) || list.length === 0) return undefined;
                        return list.map((it: any, index: number): ResumeItem => ({
                          id: it.id ?? `resume-${index}-${detail?.programManager?.id ?? index}`,
                          documentName: it.documentName ?? '',
                          status: it.status ?? 'not_started',
                          targetDate: it.date ?? it.targetDate ?? appDeadline ?? '',
                          quickLink: it.link ?? it.quickLink ?? '',
                          notes: it.notes ?? '',
                        }));
                      })()}
                      addResumeTrigger={addResumeTrigger}
                      onClose={() => setResumeExpanded(false)}
                      onSubmit={(items) => {
                        console.log('Resumes submitted:', items);
                      }}
                    />
                  )}
                </div>
                {/* Card 5: Essays - array, bấm "+ Add Essay" mở dropdown */}
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: isMobile ? '14px 16px' : '16px 20px',
                      backgroundColor: '#fff',
                      borderRadius: essaysExpanded ? '12px 12px 0 0' : '12px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      border: '1px solid #e5e7eb'
                    }}
                  >
                    <span style={{ color: '#111827', fontSize: '15px', fontWeight: 500 }}>
                      5. Essays
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        setEssaysExpanded(true);
                        setAddEssayTrigger((t) => t + 1);
                      }}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#2563eb',
                        color: '#fff',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >
                      <AddIcon sx={{ fontSize: '18px' }} /> Add Essay
                    </button>
                  </div>
                  {essaysExpanded && (
                    <EssaysDropdown
                      key={`essays-${detail?.programManager?.id ?? 'none'}`}
                      programManagerId={detail?.programManager?.id}
                      applicationDeadline={applicationDeadline}
                      initialItems={(() => {
                        const list = (detail?.programManager as any)?.essays;
                        const a = (detail?.programManager as any)?.application_form || {};
                        const appDeadline = applicationDeadline || (a.applicationDeadline ?? a.application_deadline ?? a.targetDate ?? '');
                        if (!Array.isArray(list) || list.length === 0) return undefined;
                        return list.map((it: any, index: number): EssayItem => ({
                          id: it.id ?? `essay-${index}-${detail?.programManager?.id ?? index}`,
                          title: it.title ?? '',
                          prompt: it.prompt ?? '',
                          status: it.status ?? 'not_started',
                          targetDate: it.targetDate ?? it.date ?? appDeadline ?? '',
                          wordCount: it.wordCount ?? '',
                          notes: it.notes ?? '',
                          quickLink: it.link ?? it.quickLink ?? '',
                        }));
                      })()}
                      addEssayTrigger={addEssayTrigger}
                      onClose={() => setEssaysExpanded(false)}
                      onSubmit={(items) => {
                        console.log('Essays submitted:', items);
                      }}
                    />
                  )}
                </div>

                {/* Overlay khóa khi isTrial - chỉ hiện sau khi đã load subscription, tránh nháy lock khi reload */}
                {stripeSubscriptionInfoLoaded && isTrial && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(76, 92, 107, 0.78)',
                      borderRadius: '12px',
                      zIndex: 10,
                      pointerEvents: 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      padding: '24px 16px',
                    }}
                  >
                    <div
                      style={{
                        width: 56,
                        height: 56,
                        borderRadius: '50%',
                        backgroundColor: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '8px',
                      }}
                    >
                      <LockIcon sx={{ fontSize: 28, color: '#007bff' }} />
                    </div>
                    <span style={{ fontSize: '1.15rem', fontWeight: 600, color: '#fff', textAlign: 'center', marginBottom: '4px' }}>
                      Unlock
                    </span>
                    <span style={{ fontSize: '1.1rem', fontWeight: 700, color: '#fff', textAlign: 'center', marginBottom: '12px' }}>
                      Management Features
                    </span>
                    <span
                      style={{
                        fontSize: '0.875rem',
                        color: 'rgba(255,255,255,0.95)',
                        textAlign: 'center',
                        marginBottom: '16px',
                        lineHeight: 1.5,
                        maxWidth: 260,
                      }}
                    >
                      Upgrade to Silver+ to save unlimited programs, manage your applications, requirements, and set personal reminders.
                    </span>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', maxWidth: 140 }}>
                      <button
                        type="button"
                        onClick={() => history.push(appRoutes.upgradeToSilverPlus.path)}
                        style={{
                          padding: '10px 16px',
                          borderRadius: '8px',
                          border: 'none',
                          backgroundColor: '#007bff',
                          color: '#fff',
                          fontSize: '0.9rem',
                          fontWeight: 600,
                          cursor: 'pointer',
                        }}
                      >
                        View Plans
                      </button>
                      <button
                        type="button"
                        onClick={() => window.open('https://www.gradmap.com/pricing/', '_blank')}
                        style={{
                          padding: '10px 16px',
                          borderRadius: '8px',
                          border: '1px solid #dee2e6',
                          backgroundColor: '#fff',
                          color: '#333',
                          fontSize: '0.9rem',
                          fontWeight: 500,
                          cursor: 'pointer',
                        }}
                      >
                        Learn More
                      </button>
                    </div>
                  </div>
                )}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </Container>
      <ModalConfirm
        open={deleteReminderIdx !== null}
        handleClose={() => setDeleteReminderIdx(null)}
        handleConfirm={() => {
          if (deleteReminderIdx !== null) {
            handleDeleteReminder(deleteReminderIdx);
            setDeleteReminderIdx(null);
          }
        }}
        title="Delete reminder"
        message="Are you sure to delete this reminder?"
        confirmText="Delete"
        cancelText="Cancel"
        confirmColor="error"
        showWarningIcon
      />
    </div>
  );
};

export default ProgramsPage;
